import type { AgentId } from '@developerz/domain';
import type { JSX } from 'solid-js';
import { t } from '../i18n';
import { ActionDrawer } from './ActionDrawer';
import { AgentQueuePanel } from './AgentQueuePanel';

// The drawer an agent card's "View queue" button opens (#6210): the shared
// `ActionDrawer` (its focus trap, scroll lock and exit slide) over one agent's queue.
// Open/close state lives in the card, beside the button's `aria-expanded`.

/**
 * The `ActionDrawer` titled for `agentName`, holding that agent's queue panel while `open`.
 * `handOverModel` is the card's own pin (`pinTriggerValue`), null for Automatic.
 */
export function AgentQueueDrawer(props: {
  readonly agent: AgentId;
  readonly agentName: string;
  readonly open: boolean;
  readonly onClose: () => void;
  readonly token: string | null;
  readonly handOverModel: string | null;
}): JSX.Element {
  return (
    <ActionDrawer
      open={props.open}
      title={t('agents.queue.title', { agent: props.agentName })}
      onClose={props.onClose}
    >
      <AgentQueuePanel
        agent={props.agent}
        agentName={props.agentName}
        open={props.open}
        token={props.token}
        handOverModel={props.handOverModel}
      />
    </ActionDrawer>
  );
}
